import { FileUploadListener } from './../classes/FileUploadListener';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import * as JSZip from 'jszip';
import { OwnListService } from '../own-list.service';
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';
import { StringHelper } from '../helpers/StringHelper';

@Component({
  selector: 'app-import-itunes-lib',
  templateUrl: './import-itunes-lib.component.html',
  styleUrls: ['./import-itunes-lib.component.scss'],
  providers: [ OwnListService ]
})
export class ImportItunesLibComponent extends BaseComponent implements OnInit, FileUploadListener {

  MAX_FILE_SIZE_BYTES = 128000000;

  @ViewChild('browseInput', {static: false}) browseInput;
  pages: number = 5;
  currentPageNo = 0;
  @Output() onClose = new EventEmitter();
  @Output() onNext = new EventEmitter<number>();

  isUploading = false;
  uploadSuccessful = true;
  percentage = "0";
  successCount = 0;
  uploadErrorMessage = "";

  moviesOn = true;
  tvOn = true;
  fileOK = false;
  invalidFile = false;
  fileTooBig = false;

  errorMessage = "";
  file;
  generatedZipFile;

  isV2: boolean = false;
  v2DataToUpload: string;
  importv2Results: string;

  constructor(
    private ownlistService: OwnListService
  ) {
    super();
  }

  ngOnInit() {
  }

  next() {

    if (!this.moviesOn && !this.tvOn) {
      this.errorMessage = this.getString("importiTunesPage3Checkbox");
      return;
    }

    if(this.currentPageNo === 2 && this.isV2) {
      this.ownlistService.importMediaLibrary_v2(btoa(encodeURI(this.v2DataToUpload)), Global.getCountry(), Global.getStore(), StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe(res => {
        this.uploadSuccessful = false;
        if(res) {
          if(res["status"] == "success" && res["additionalInfo"]) {
            this.uploadSuccessful = true;
            this.importv2Results = (res["additionalInfo"]["unmatchableTitles"] || "").split('|').join('\n');
            this.successCount = res["additionalInfo"]["addedCount"];
          }
          else {
            this.uploadErrorMessage = (res["additionalInfo"] && res["additionalInfo"]["message"]) ? res["additionalInfo"]["message"] : this.getString("error");
          }
        }
        this.slideToNextPage();
      }, err => {
        this.uploadSuccessful = false;
        this.uploadErrorMessage = this.getString("error");
        this.slideToNextPage();
      });
      return;
    }
    if (this.currentPageNo === 3 && !this.isV2) {

      if (this.file) {
        this.isUploading = true;
        this.zipFile(this.file);
        return;
      }
      else if (this.generatedZipFile && this.isUploading) {
        this.isUploading = false;
      }
      else if (!this.generatedZipFile) {
        this.invalidFile = true;
        return;
      }

    }

    this.slideToNextPage();

  }

  back() {
    this.currentPageNo--;
    if(this.currentPageNo < 2) {
      this.isV2 = false; this.pages = 5;
    }

    const content = document.getElementsByClassName("content-ii")[0];
    let w = content.clientWidth;
    const interval = setInterval(() => {
      if (w > 0) {
        const pixelsToScroll = w > 40 ? 40 : w;
        w -= pixelsToScroll;
        const element = document.getElementsByClassName("slide-container-ii")[0];
        if (element && element.scrollBy) {
          element.scrollBy(-pixelsToScroll, 0);
        }

      }
      else {
        clearInterval(interval);
      }
    }, 25);
  }

  slideToNextPage() {
    if (this.currentPageNo < this.pages - 1) {
      this.currentPageNo++;
    }

    this.onNext.emit(this.currentPageNo);
    const content = document.getElementsByClassName("content-ii")[0];
    if (!content) { return; }

    let w = content.clientWidth;
    const interval = setInterval(() => {
      if (w > 0) {
        const pixelsToScroll = w > 40 ? 40 : w;
        w -= pixelsToScroll;
        const element = document.getElementsByClassName("slide-container-ii")[0];
        if (element && element.scrollBy) {
          element.scrollBy(pixelsToScroll, 0);
        }

      }
      else {
        clearInterval(interval);
      }
    }, 25);
  }

  close() {
    this.onClose.emit();
  }

  cbMoviesChanged(value) {
    this.moviesOn = value;
    this.errorMessage = "";
  }

  cbTVChanged(value) {
    this.tvOn = value;
    this.errorMessage = "";
  }

  chooseFile() {
    this.browseInput.nativeElement.click();
    return false;
  }

  zipFile(file) {
    const zip = new JSZip();
    zip.file("Library.xml", file);
    const self = this;
    zip.generateAsync({type: "blob", compression: "DEFLATE", compressionOptions: { level: 9 }})
    .then(function(generatedZip) {
      const medias = [];
      if (self.moviesOn) { medias.push(Global.MOVIES); }
      if (self.tvOn) { medias.push(Global.TV); }
      self.generatedZipFile = generatedZip;
      if (generatedZip.size > self.MAX_FILE_SIZE_BYTES) {
        self.fileOK = false;
        self.fileTooBig = true;
        return;
      }
      self.ownlistService.importMediaLibrary(self.generatedZipFile, self, Global.getCountry(), Global.getStore(),
      medias.join(','), StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe(res => {
        self.file = null;
        try{
          res = JSON.parse(res);
        }
        catch (e) {
          self.uploadSuccessful = false;
          self.uploadErrorMessage = self.getString("error");
          self.next();
        }
        if (res) {
          if (res.status === "error") {
            self.uploadSuccessful = false;
            self.uploadErrorMessage = res.message;
          }
          else if (res.additionalInfo) {
            self.successCount = res.additionalInfo.addedCount;
          }
        }
        self.next();
      }, err => {
        self.file = null;
        self.uploadSuccessful = false;
        self.uploadErrorMessage = "";
        self.next();
      });
    });
  }

  handleSelectedLocalFiles(e) {

    this.fileOK = false;
    this.invalidFile = false;

    const files: FileList = (e.srcElement || e.target).files;

    const filesArray = [];
    for (let i = 0; i < files.length; i++) {
      filesArray.push(files.item(i));
    }
    if (filesArray.length > 0){

      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        const fileContent = fileReader.result;
        if (fileContent.toString().startsWith("<?xml")) {
          this.fileOK = true;
        }
        else {
          this.invalidFile = true;
        }
      };
      fileReader.readAsText(filesArray[0]);
      this.file = filesArray[0];
    }
    this.browseInput.nativeElement.value = "";
  }

  onProgress(file: any, progressPercentage: number) {
    this.percentage = progressPercentage.toFixed(0);
  }

  getSuccessCountText(): string {
    return StringHelper.format(this.getString('importiTunesPage4SuccessText1'), "" + this.successCount);
  }

  getErrorMessageText(): string {
    return StringHelper.format(this.getString('importPage4ErrorText2'), "" + this.uploadErrorMessage);
  }

}

export class Page {
  text: string;
  img: string;
}
